import { Options, Vue } from "vue-class-component";
import { reactive, ref } from 'vue';
import NavBar from "./components/nav/index.vue";
import FooterBar from "./components/footer/index.vue";
import AppMain from "./components/main/index.vue";
import { ElMessage } from 'element-plus';
import { getEnum  } from "@/api/index";
import { addApply  } from "@/api/backstage";
import type { ElForm } from "element-plus";
import { fa } from "_element-plus@2.1.1@element-plus/lib/locale";
 

type FormInstance = InstanceType<typeof ElForm>;
@Options({
  components: {
    NavBar,
    FooterBar,
    AppMain,
  },
})
export default class Home extends Vue {
  public ruleFormRef = ref<FormInstance>();
 
  public isMobile = false;

  public dialogVisible = false;

  public types: any={};
  public productType: any = {};
  public ruleForm = {
    userName:'',
    telephone:'',
    orgName:'',
    agencyStatus:'',
    email:'',
    productType:'',
  }

  public rules = {
    userName: [
      { required: true, message: "请输入申请人", trigger: "blur" },
      { pattern: /^[\u4e00-\u9fa5_a-zA-Z0-9]+$/, message: "请勿输入特殊字符", trigger: "blur",},
    ],
    telephone: [
      { required: true, message: "请输入联系人电话", trigger: "blur" },
      { pattern: /^0?1(3|4|5|7|8)\d{9}$/, message: "请输入正确的手机号", trigger: "blur",},
    ],
    orgName: [
      { required: true, message: "请输入申请单位", trigger: "blur" },
      { pattern: /^[\u4e00-\u9fa5_a-zA-Z0-9]+$/, message: "请勿输入特殊字符", trigger: "blur",},
    ],
    agencyStatus: [
      { required: true, message: "请选择类型", trigger: "blur" },
    ],
    email: [
      {pattern: /^\w+@[a-zA-Z0-9]+((\.[a-z0-9A-Z]{1,})+)$/, message: "请输入正确的邮箱地址", trigger: "blur", },
    ],
  }

  public getWidth = () => {
    const screenWidth = document.body.clientWidth;
    screenWidth < 750 ? (this.isMobile = true) : (this.isMobile = false);
  };

  public created() {
    if (this.$route.path === "/") this.$router.push("/home");
    window.addEventListener("resize", this.getWidth);
    this.getWidth();
    this.getProuType();
    this.getType();
  }

  public gotop(){
    let sTop = document.documentElement.scrollTop || document.body.scrollTop;
    if (sTop > 0) {
      window.requestAnimationFrame(this.gotop);
      window.scrollTo(0, sTop - sTop / 5);
    }
  }

  public cancel(formEl: FormInstance | undefined){
    if (!formEl) return;
    formEl.resetFields();
    this.dialogVisible = false;
  }

  public getProuType() {
    getEnum('PRODUCT').then((res: any) => {
      for (const item of res.data) {
        this.productType[item.enumKey] = item;
      }
      });
    }

    public getType() {
      getEnum('AGENCY').then((res: any) => {
        for (const item of res.data) {
          this.types[item.enumKey] = item;
        }
        });
      }
    
    public submitForm(formEl: any) {
      if (!formEl) return;
      formEl.validate((valid: any) => {
        if (valid) {
          this.postAppy();
          formEl.resetFields();
        } else {
          console.log('error submit!');
          return false;
        }
      });
    }

    public postAppy(){
      addApply(this.ruleForm).then((res: any)=>{
        if(res.code===200){
          ElMessage({
            message: res.msg,
            type: 'success',
          });
          this.dialogVisible = false;
        }
      });
    }
  
}
